"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidatesContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../schemas");
const candidates_detail_response_1 = require("./candidates-detail.response");
const candidates_list_response_1 = require("./candidates-list.response");
const candidates_request_1 = require("./candidates.request");
const c = (0, core_1.initContract)();
exports.CandidatesContract = c.router({
    search: {
        method: 'GET',
        path: '/',
        query: candidates_request_1.CandidateSearchQuerySchema,
        responses: {
            200: candidates_list_response_1.CandidateSearchListResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    findById: {
        method: 'GET',
        path: '/:candidateId',
        pathParams: candidates_request_1.CandidateIdPathParamsSchema,
        responses: {
            200: candidates_detail_response_1.CandidateProfileResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
}, { pathPrefix: '/candidates' });
